// Libs
import { put, call, take, select } from 'redux-saga/effects'

// Constants
import { POST_EULA_STATUS, ACCEPT_EULA_URL, EFFECTIVE_DATE } from '../constants'

// Selectors
import { currentUser$ } from 'hfty-users'

// Utils
import { __post } from 'hfty-fetch'

// Actions
import { acceptEula } from '../actions'

export default function *watchAcceptEula () {
  yield take(POST_EULA_STATUS)

  const currentUser = yield select(currentUser$)
  try {
    const response = yield call(__post, {
      path: ACCEPT_EULA_URL,
      body: {
        client: currentUser.id,
        version: EFFECTIVE_DATE,
        type: 'hefty',
      },
    })
    if (response && response.ok) {
      yield put(acceptEula(true))
    } else yield put(acceptEula(false))
  } catch (error) {
    console.warn('EULA post acceptance error: ' + error)
    yield put(acceptEula(false))
  }
}
